export const generalTimeTabling = {
  id: "MENU_GENERAL_TIME_TABLING",
  icon: "AnalyticsIcon",
  text: "Thời khóa biểu",
  child: [
    {
      id: "MENU_GENERAL_TIME_TABLING.UPLOAD_SCREEN",
      path: "/general-time-tabling/plan-class-open",
      isPublic: true,
      text: "Kế hoạch mở lớp",
      child: [],
    },
    {
      id: "MENU_CLASS_PLAN.LIST_BATCH",
      path: "/general-time-tabling/list-batch",
      isPublic: true,
      text: "Kế hoạch mở lớp (new)",
      child: [],
    },
    {
      id: "MENU_GENERAL_TIME_TABLING.UPLOAD_SCREEN",
      path: "/general-time-tabling/plan-class-open-summer",
      isPublic: true,
      text: "Kế hoạch mở lớp kỳ hè",
      child: [],
    },
    {
      id: "MENU_GENERAL_TIME_TABLING.UPLOAD_SCREEN",
      path: "/general-time-tabling/upload-class",
      isPublic: true,
      text: "Danh sách lớp",
      child: [],
    },
    //{
    //  id: "MENU_GENERAL_TIME_TABLING.GROUP_SCREEN",
    //  path: "/general-time-tabling/group-class",
    //  isPublic: false,
    //  text: "Phân nhóm lớp",
    //  child: [],
    //},
    {
      id: "MENU_GENERAL_TIME_TABLING.SCHEDULE_SCREEN",
      path: "/general-time-tabling/schedule-class",
      isPublic: true,
      text: "Xếp thời khóa biểu",
      child: [],
    },
    {
      id: "MENU_TIMETABLING.MAKE_TIMETABLING",
      path: "/general-time-tabling/list-batch-make-timetabling",
      isPublic: true,
      text: "Xếp thời khóa biểu (new)",
      child: [],
    },
    {
      id: "MENU_GENERAL_TIME_TABLING.SCHEDULE_SCREEN_SUMMER",
      path: "/general-time-tabling/schedule-class-summer",
      isPublic: true,
      text: "Xếp thời khóa biểu kỳ hè",
      child: [],
    },
    {
      id: "MENU_GENERAL_TIME_TABLING.ROOM_OCCUPATION",
      path: "/general-time-tabling/room-occupation",
      isPublic: true,
      text: "Xem tình trạng phòng học",
      child: [],
    },
    {
      id: "MENU_GENERAL_TIME_TABLING.FIND_EMPTY_ROOM",
      path: "/general-time-tabling/find-empty-room",
      isPublic: true,
      text: "Tìm phòng học trống",
      child: [],
    },
    {
      id: "MENU_GENERAL_TIME_TABLING.FIND_EMPTY_ROOM",
      path: "/general-time-tabling/find-empty-room",
      isPublic: true,
      text: "Tìm phòng học trống",
      child: [],
    },
  ],
};
